/* 🤖 this file was generated by svg-to-ts */
export const matIconMouse: {
  name: 'mouse';
  data: string;
} = {
  name: 'mouse',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 9c-.04-4.39-3.6-7.93-8-7.93S4.04 4.61 4 9v6c0 4.42 3.58 8 8 8s8-3.58 8-8V9zm-2 0h-5V3.16c2.81.47 4.96 2.9 5 5.84zm-7-5.84V9H6a6.005 6.005 0 0 1 5-5.84zM18 15c0 3.31-2.69 6-6 6s-6-2.69-6-6v-4h12v4z"/></svg>`
};
